import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Col, Modal, Row } from "react-bootstrap";
import LoadMap from "./LoadMap";
import LoadTimeLine from "./LoadTimeLine";
import { getLoadTimeLine } from "../../actions/load";
import { Heading6 } from "../widgets";
import { isAutomaticLoad } from "../../helpers/common";
import "../../../assets/scss/loadhistory-popup.scss";

const LoadLocationPopUp = (props) => {
  const { load, show, onHide } = props;
  const { farmId } = useParams();
  const dispatch = useDispatch();

  const [loadInfo, setLoadInfo] = useState(null);

  const regionsDetail = useSelector((state) => state.geo.regionsDetails);
  const regionsDetailRequesting = useSelector(
    (state) => state.geo.isRegionsDetailsRequesting
  );
  const isTimeLineRequesting = useSelector(
    (state) => state.load.loadTimeLine.isRequesting
  );

  useEffect(() => {
    if (!show) setLoadInfo(null);
    else {
      const { load_activity_uuid, events } = load || {};

      let loadLocation =
        events && events.length !== 0
          ? events.filter((e) => e.event_status === (isAutomaticLoad() ? 1 : 4))
          : [];
      loadLocation =
        loadLocation.length !== 0
          ? loadLocation.map((e) => {
              return {
                lat: e.latitude,
                lng: e.longitude,
              };
            })
          : [];

      setLoadInfo({
        ...load,
        location: loadLocation,
      });

      dispatch(
        getLoadTimeLine({
          farm_uuid: farmId,
          load_activity_uuid: load_activity_uuid,
        })
      );
    }
  }, [show, load]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      className="modal-loadpopup"
      centered
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <Heading6>Load Timeline + Location</Heading6>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="py-0">
        {!isTimeLineRequesting && !regionsDetailRequesting ? (
          <Row>
            <>
              <Col
                className="col-5"
                style={{ paddingRight: "0px", paddingLeft: "5px" }}
              >
                <LoadTimeLine
                  loadActivityId={load.load_activity_uuid}
                  loadInfo={loadInfo}
                />
              </Col>
              <Col className="col-7 map">
                {regionsDetailRequesting || !loadInfo ? (
                  <div
                    style={{ position: "relative", top: "45%", left: "45%" }}
                  >
                    Loading...
                  </div>
                ) : (
                  <LoadMap
                    location={
                      loadInfo && loadInfo.location.length !== 0
                        ? loadInfo.location
                        : []
                    }
                    loadInfo={loadInfo}
                    regionsDetail={regionsDetail}
                  />
                )}
              </Col>
            </>
          </Row>
        ) : (
          <div style={{ position: "relative", top: "45%", left: "45%" }}>
            Loading...
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default LoadLocationPopUp;